import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useEffect, useState } from 'react';

const J: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneJ = AniContainer.create({
                triggerElement: '.stream-ultra-x-E',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                sceneJ.destroy();
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} stream-ultra-x-J GtmModuleData-section`}
            id="stream-ultra-x-J"
            data-section-id={'stream-ultra-x-J'}
            data-section-title={t('J_title')}
        >
            <div className="sticky">
                <div className="box1 box">
                    <p className="title">{t('J_title')}</p>
                    <div className="inner">
                        <EcoImg
                            className="img"
                            pc={'https://websiteoss.ecoflow.com/upload/image/1754312515022/10_1.jpg'}
                            h5={'https://websiteoss.ecoflow.com/upload/image/1754312515004/10_1_M.jpg'}
                            isOpenLazy={true}
                        />
                        <div className="info">
                            <p className="info-title">{t('J_item1_title')}</p>
                            <p className="info-desc">{t('J_item1_desc')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="box2 box">
                <p className="title">{t('J_title')}</p>
                <div className="inner">
                    <div className="img">
                        <EcoImg
                            className="img"
                            pc={'https://websiteoss.ecoflow.com/figma-uploads/1756197336926-qyl4m0-compressed-%E4%B8%8D%E4%B8%8A%E4%BA%91%E7%AB%AF%202.jpg'}
                            h5={'https://websiteoss.ecoflow.com/figma-uploads/1756197390966-oqsq9v-compressed-%E4%B8%8D%E4%B8%8A%E4%BA%91%E7%AB%AF%202.jpg'}
                            isOpenLazy={true}
                        />
                    </div>
                    <div className="info">
                        <p className="info-title">{t('J_item2_title')}</p>
                        <p className="info-desc">{t('J_item2_desc')}</p>
                        <p className="info-tip">{t('J_item2_tip')}</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default J;
